import {
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from 'react-query';
import { ErrorType } from '../../client/apiClient';

type QueryResult<T> = T extends UseQueryOptions<infer P, unknown, unknown, any>
  ? P
  : never;

/**
 * Permette di chiamare un qualunque endpoint di tipo GET utilizzando
 * la relativa `get<Endpoint>QueryOptions()`.
 */
export function useGetQuery<
  O,
  T extends (...inputs: any[]) => any,
  TData = QueryResult<Awaited<ReturnType<T>>>,
  TError = ErrorType<unknown>,
>(getQueryOptions: T, inputs: Parameters<T>) {
  const queryOptions = getQueryOptions(...inputs);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
